import React, { useState, useContext } from 'react';
import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import { HomeContext } from '../utils/contexts/homeContext';
import { GetNurseSeachAPIUrl } from '../utils/extensions/functionEx';
import { styled } from '@mui/material/styles';
import { Button, InputBase, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { useCookies } from 'react-cookie';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const NurseSearchDialog = (props) => {

    const { ShowAPIError, OpenErrorAlert, homeState, ClearLoggedUser } = useContext(HomeContext);

    const [searchText, setSearchText] = useState('');
    const [dbNurses, setDbNurses] = useState([]);
    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);

    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    const searchNurses = async (searchText) => {
        try {
            setIsOpenPageLoad(true);
            let tempNurses = [];

            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(GetNurseSeachAPIUrl(homeState.loggedUser.companyCode, searchText, true), { headers: headers });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempNurses = await response.json();
            } else {
                ShowAPIError(response)
            }
            setDbNurses([...tempNurses]);
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
        }
    }

    const handleSearchClick = async () => {
        await searchNurses(searchText.trim());
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={props.handleCloseClick}
                open={props.isOpen}
                fullWidth
                maxWidth={'md'}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    Select New Nurse
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={props.handleCloseClick}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Stack>
                        <Box sx={{ mb: 1 }}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="stretch"
                            >
                                <Grid size={12}>
                                    <Paper variant="outlined"
                                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                                    >
                                        <InputBase value={searchText}
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Search Nurse"
                                            onChange={(event) => {
                                                setSearchText(event.target.value);
                                            }}
                                        />
                                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search nurse" onClick={handleSearchClick}>
                                            <SearchIcon />
                                        </IconButton>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                        {
                            isOpenPageLoad && <Box sx={{ textAlign: 'center', padding: '10px' }}>
                                <CircularProgress size="30px" />
                            </Box>
                        }
                        {
                            !isOpenPageLoad &&
                            <Box>
                                <TableContainer component={Paper} sx={{ borderRadius: '0' }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Name</StyledTableCell>
                                                <StyledTableCell>Phone Nos</StyledTableCell>
                                                <StyledTableCell align="center" sx={{ width: '55px' }}></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dbNurses.map((row) => (
                                                <StyledTableRow key={row.id.toString()}>
                                                    <StyledTableCell>{row.nurse_name}</StyledTableCell>
                                                    <StyledTableCell>{row.phone}</StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <Button onClick={() => props.handleNurseSelectClick(row)}>
                                                            Select
                                                        </Button>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        }
                    </Stack>
                </DialogContent>
            </BootstrapDialog>
        </React.Fragment>

    );
}

export default NurseSearchDialog;